<template>
  <v-menu offset-y v-bind="$attrs" :rounded="roundedMenu" v-on="$listeners">
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="{ ...attrs, ...$attrs }"
        :min-width="btnWidth"
        :text="btnTypeText"
        :color="color"
        :class="btnClass"
        v-on="on"
      >
        <span>{{ title || value }}</span>
        <v-icon v-if="showIcon" :size="18" :color="iconColor" :right="!!title.length">
          {{ icon }}</v-icon
        >
      </v-btn>
    </template>

    <slot name="list" :items="listItems">
      <v-list class="cfs-dropdown-list">
        <v-list-item-group @change="onChangeHandler">
          <v-list-item
            v-for="(item, index) in listItems"
            :key="item + index"
            :class="{ 'opacity-50 pointer-events-none': item.disabled }"
            :value="item.title"
            @click="item.handler(item, index)"
          >
            <v-list-item-icon v-if="item.icon" class="mr-1">
              <v-icon
                v-if="typeof item.icon === 'string' && item.icon.startsWith('mdi')"
                :class="`${item.iconClasses || ''} !text-[20px]`"
              >
                {{ item.icon }}
              </v-icon>
              <CfsIcon
                v-else-if="typeof item.icon === 'string'"
                :icon-name="item.icon"
                :max-width="item.iconWidth"
                :max-height="item.iconHeight"
              />
              <component :is="item.icon" v-else />
            </v-list-item-icon>
            <v-list-item-title class="cfs-dropdown-list__title whitespace-nowrap">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </slot>
  </v-menu>
</template>

<script>
export default {
  name: 'CfsDropdownComponent',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: [String, Number],
      required: true,
      default: 'Dropdown',
    },
    btnClass: {
      type: String,
      default: '',
    },
    btnWidth: {
      type: String,
      default: '',
    },
    btnTypeText: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    iconColor: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: '',
    },
    roundedMenu: {
      type: String,
      default: '0',
    },
    icon: {
      type: String,
      default: 'mdi-chevron-down',
    },
  },
  computed: {
    listItems() {
      if (!this.items.length) {
        return [];
      }
      return this.items.map((item) => {
        if (typeof item !== 'object') {
          return { title: item, handler: this.defaultHandler };
        }
        if (!item.handler) {
          return { ...item, handler: this.defaultHandler };
        }
        return item;
      });
    },
  },
  methods: {
    defaultHandler(item, index) {
      this.$emit('click-item', item, index);
    },
    onChangeHandler(item) {
      this.$emit('change', item);
    },
  },
};
</script>
